import { reactive } from "vue";
import { Module } from "vuex";
import { AxiosResponse } from "axios";
import interactiveMasterplanApi from "@/services/api/interactiveMasterplanApi";
import { CreateInteractiveMasterplanInterface } from "@/types/InteractiveMasterplanInterface";

const state = reactive({});

export type InteractiveMasterplanState = typeof state;

const interactiveMasterplanStore: Module<InteractiveMasterplanState, never> = {
  namespaced: true,
  state,
  actions: {
    getMasterplans(_, params = {}): Promise<AxiosResponse> {
      return interactiveMasterplanApi.getMasterplans(params);
    },

    getMasterplan(_, id: string): Promise<AxiosResponse> {
      return interactiveMasterplanApi.getMasterplan(id);
    },

    getMasterplanByEstateId(_, estateId: string): Promise<AxiosResponse> {
      return interactiveMasterplanApi.getMasterplanByEstateId(estateId);
    },

    getHouseDesignsWithLots(_, estateId: string): Promise<AxiosResponse> {
      return interactiveMasterplanApi.getHouseDesignsWithLots(estateId);
    },

    createMasterplan(
      _,
      data: CreateInteractiveMasterplanInterface
    ): Promise<AxiosResponse> {
      return interactiveMasterplanApi.createMasterplan(data);
    },

    updateMasterplan(
      _,
      payload: {
        id: string;
        data: Partial<CreateInteractiveMasterplanInterface>;
      }
    ): Promise<AxiosResponse> {
      return interactiveMasterplanApi.updateMasterplan(
        payload.id,
        payload.data
      );
    },

    deleteMasterplan(_, id: string): Promise<AxiosResponse> {
      return interactiveMasterplanApi.deleteMasterplan(id);
    },

    uploadSvgFile(_, data: FormData): Promise<AxiosResponse> {
      return interactiveMasterplanApi.uploadSvgFile(data);
    },

    deleteSvgFile(
      _,
      data: { fileName: string; userId: string; estateId: string }
    ): Promise<AxiosResponse> {
      return interactiveMasterplanApi.deleteSvgFile(data);
    },
  },
};

export default interactiveMasterplanStore;
